export enum ClosedType {
    ANY = 'any',
    WON = 'won',
    OPEN = 'open',
    CLOSED = 'closed'
}
